import React from "react";
import HeaderComponent from "components/card/HeaderComponent";
import { LucideUsers } from "lucide-react";
import SelectTeamCard from "./SelectTeamCard";

export default function SelectTeam({
  selectedMembers = [], 
  setSelectedMembers,
  selectedCourse,
  enrolledUserIds,
}) {
 
  return (
    <div className="flex flex-col">
      <HeaderComponent
        title="Step 2: Select Team"
        titleClass="text-lg dark:text-white"
        description={`${selectedMembers.length} members selected`}
        bgcolor="bg-gradient-to-br from-emerald-50 to-cyan-50 dark:from-emerald-900 dark:to-white/10"
        icon={<LucideUsers className="text-white" size={20}/>}
        colorTheme="gradient-cyan"
        rightNav={
          selectedMembers.length > 0 && (
            <div className="px-3 py-1 rounded-full bg-emerald-500 text-white text-[12px] font-semibold">
              {`${selectedMembers.length}`}
            </div>
          )      
        }
      >
        <div className="pt-10">
          <SelectTeamCard
            selectedMembers={selectedMembers}
            setSelectedMembers={setSelectedMembers}
            selectedCourse={selectedCourse} 
            enrolledUserIds={enrolledUserIds}
          />
        </div>
        
      </HeaderComponent>
    </div>
  );
}
